import { render } from "./ChartPph.vue?vue&type=template&id=218bea74"
import script from "./ChartPph.vue?vue&type=script&lang=js"
export * from "./ChartPph.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__